import { Instagram, Video, ArrowUpRight } from "lucide-react";
import { Reveal, Overline } from "../components/Reveal";
import { PULKITVEER_INSTAGRAM } from "../data/content";

export const PulkitveerCollab = () => (
  <section id="analyst" className="py-24 sm:py-32 scroll-mt-16" data-testid="analyst-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-12">
      <Reveal>
        <Overline>ISL-Level Collaboration</Overline>
        <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-black uppercase tracking-tight mt-3 max-w-3xl">
          Monthly analyst sessions with <span className="text-[#D4AF37]">Pulkit Veer.</span>
        </h2>
      </Reveal>

      <div className="mt-12 grid lg:grid-cols-[1fr_1fr] gap-8 lg:gap-14 items-center">
        <Reveal delay={0.1}>
          <div className="border border-white/10 bg-[#050505] p-6 sm:p-8">
            <div className="flex items-start gap-4">
              <div className="w-16 h-16 shrink-0 rounded-full overflow-hidden ring-2 ring-[#D4AF37]/40">
                <img src="/assets/pulkitveer.jpg" alt="Pulkit Veer — FC Goa analyst" className="w-full h-full object-cover" data-testid="pulkit-avatar" />
              </div>
              <div>
                <p className="font-heading text-xl font-black uppercase tracking-tight">Pulkit Veer</p>
                <p className="text-[#D4AF37] text-xs uppercase tracking-widest font-bold mt-1">Analyst · FC Goa (ISL)</p>
                <p className="text-white/50 text-xs mt-1">@footywveer</p>
              </div>
            </div>
            <p className="text-white/70 text-[15px] leading-relaxed mt-6">
              Zavi players benefit from monthly video analysis sessions with Pulkit Veer, an analyst working with one of India's top-flight ISL clubs, FC Goa. These sessions decode real match footage — teaching young players how professionals scan, read pressure, position themselves and make decisions.
            </p>
            <p className="text-white/55 text-sm mt-4 leading-relaxed">
              It's exposure our players wouldn't ordinarily get at their age — the same analytical language used inside professional football, delivered directly into our training environment.
            </p>
            <a href={PULKITVEER_INSTAGRAM} target="_blank" rel="noreferrer"
              className="mt-6 inline-flex items-center gap-2 bg-[#D4AF37] text-black font-bold uppercase tracking-widest text-xs px-5 py-3 hover:bg-[#F3D059] transition-colors duration-200"
              data-testid="pulkit-follow">
              <Instagram size={14} /> Follow @footywveer <ArrowUpRight size={12} />
            </a>
          </div>
        </Reveal>

        <Reveal delay={0.2}>
          <div className="grid grid-cols-2 gap-3">
            {[
              { title: "Ball Knowledge", text: "Understanding what to do before the ball arrives." },
              { title: "Match Reading", text: "Reading pressure, space and opposition patterns in real time." },
              { title: "Professional Eye", text: "The analytical language used inside ISL setups." },
              { title: "Monthly Cadence", text: "Consistent sessions across the season — not one-off gimmicks." },
            ].map((c, i) => (
              <div key={c.title} className="border border-white/10 bg-black p-5 hover:border-[#D4AF37]/30 transition-colors duration-300" data-testid={`pulkit-card-${i}`}>
                <Video size={16} className="text-[#D4AF37]" />
                <p className="font-heading text-sm font-black uppercase tracking-tight mt-3">{c.title}</p>
                <p className="text-white/55 text-xs mt-2 leading-relaxed">{c.text}</p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
